import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutoFocusDirective } from './auto-focus.directive';
import { BusyIfDirective } from './busy-if.directive';
import { ButtonBusyDirective } from './button-busy.directive';
import { CurrencyInputDirective } from './currency-input.directive';
import { FileDownloadService } from './file-download.service';
import { FriendProfilePictureComponent } from './friend-profile-picture.component';
import { LocalStorageService } from './local-storage.service';
import { MomentFormatPipe } from './moment-format.pipe';
import { NormalizeDropdownPositionDirective } from './normalize-dropdown-position.directive';
import { ValidationMessagesComponent } from './validation-messages.component';
import { EqualValidator } from './validation/equal-validator.directive';
import { MinValueValidator } from './validation/min-value-validator.directive';
import { PasswordComplexityValidator } from './validation/password-complexity-validator.directive';
import { NullDefaultValueDirective } from './null-value.directive';
import { ReplacePipe } from './replace.pipe';
import { AutocompleteDirective } from './autocomplete.directive';
import { EmailMultipleDirective } from './email-multiple.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        FileDownloadService,
        LocalStorageService
    ],
    declarations: [	
        EqualValidator,
        PasswordComplexityValidator,
        MinValueValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        FriendProfilePictureComponent,
        MomentFormatPipe,
        CurrencyInputDirective,
        NormalizeDropdownPositionDirective,
        ValidationMessagesComponent,
        NullDefaultValueDirective,
        ReplacePipe,
        AutocompleteDirective,
        EmailMultipleDirective
   ],
    exports: [
        EqualValidator,
        PasswordComplexityValidator,
        MinValueValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        FriendProfilePictureComponent,
        MomentFormatPipe,
        CurrencyInputDirective,
        NormalizeDropdownPositionDirective,
        ValidationMessagesComponent,
        NullDefaultValueDirective,
        ReplacePipe,
        AutocompleteDirective,
        EmailMultipleDirective
    ]
})
export class UtilsModule { }
